document.addEventListener("DOMContentLoaded", function () {
  var menuContainer = document.getElementById("overlay-menu");
  var menuClose = document.getElementById("menu-close");
  var menuIcon = document.getElementById("menu-icon");
  var headerMainNav = document.querySelector(".header__main-nav");
  var footerMain = document.querySelector(".footer");
  var menuContainer = document.getElementById("overlay-menu");
  var menuContainerMob = document.getElementById("overlay-mob");
  var menuClose = document.getElementById("menu-close");
  var menuIcon = document.getElementById("menu-icon");
  var menuIconMob = document.getElementById("menu-icon-mob");
  var menuIconMobClose = document.getElementById("menu-icon-mob-close");
  var headerMainNav = document.querySelector(".header__main-nav");
  var footerContainer = document.querySelector(".overlay-footer");

  function toggleMenuDisplay() {
    if (window.innerWidth <= 1200) {
      if (menuIconMob.classList.contains("menu-hidden")) {
        menuIconMob.style.display = "none";
        menuIconMobClose.style.display = "block";
      } else {
        menuIconMob.style.display = "block";
        menuIconMobClose.style.display = "none";
      }
      menuContainer.style.visibility = "hidden";
      footerContainer.style.display = "block";
      menuContainer.style.display = "none";
      footerMain.style.height = "1000px;";

    } else {
      if (menuIconMob.classList.contains("menu-hidden")) {
        headerMainNav.style.height = "";
        menuIconMobClose.style.display = "none";
        menuContainer.style.display = "flex";
      } else {
        menuIconMob.style.display = "none";
      }
      footerContainer.style.display = "none";
      footerMain.style.height = "";
    }
  }

  toggleMenuDisplay(); // Initial check
  window.addEventListener("resize", toggleMenuDisplay);


  menuIconMob.addEventListener("click", function () {
    menuIconMob.classList.add("menu-hidden");
    menuIconMob.style.display = "none";
    menuIconMobClose.style.display = "block";
    const searchMobContainer = document.querySelector('.header__search-mob');
    const searchIcon = document.querySelector('.search-scroll');
    searchMobContainer.classList.remove('search-only-open');
    searchMobContainer.classList.add('hidden');
    searchIcon.style.display = 'none';
  });

  menuIconMobClose.addEventListener("click", function () {
    const searchMobContainer = document.querySelector('.header__search-mob');
    const searchIcon = document.querySelector('.search-scroll');

    if (searchMobContainer.classList.contains('search-only-open')) {
      searchMobContainer.classList.remove('search-only-open');
      menuIconMob.classList.remove("menu-hidden");
      menuIconMob.style.display = "block";
      menuIconMobClose.style.display = "none";
      searchIcon.style.display = "block";
      return;
    }

    menuIconMob.classList.remove("menu-hidden");
    menuIconMob.style.display = "block";
    menuIconMobClose.style.display = "none";
    searchMobContainer.classList.remove('hidden');
    searchIcon.style.display = 'block';
  });
});
document.addEventListener("DOMContentLoaded", function () {

  let lastScrollTop = 0;
  const header = document.querySelector(".header__nav");

  window.addEventListener(
    "scroll",
    function () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > lastScrollTop) {

        header.style.transform = "translateY(-100px)";
      } else {
        header.style.transform = "translateY(0)";
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    },
    false
  );
});
function applyStyles() {

}
document.addEventListener('DOMContentLoaded', function () {

  function handleScrollAndResize() {

    let lastScrollTop = 0;
    const centerMenu = document.querySelector('.center-menu-x');

    function handleScroll() {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      const screenWidth = window.innerWidth;

      if (screenWidth > 1200) {
        if (currentScroll > lastScrollTop) {
          centerMenu.classList.add('visible');

        } else {
          centerMenu.classList.remove('visible');
        }
      } else {
        centerMenu.classList.remove('visible');
      }

      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    }

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    handleScroll();
  }
  var searchIcon = document.querySelector('.search-scroll');
  handleScrollAndResize();
  const container = document.querySelector('.search-mob-container');

  const form = document.getElementById('cart');
  const textarea = document.getElementById('CartSpecialInstructions');
  const checkbox = document.getElementById('no-need-checkbox');

  if (form) {
    form.addEventListener('submit', function (event) {
      if (checkbox && textarea && !checkbox.checked && textarea.value.trim() === '') {
        event.preventDefault();
        alert('Please fill out the URL or check "No Need" option.');
      }
    });
  }
});
document.addEventListener('DOMContentLoaded', function () {

  const cartActiveElement = document.querySelector('.header__cart-active');
  const cartCountElement = document.getElementById('cart-count-value');

  if (cartCountElement && cartActiveElement) {
    cartCountElement.textContent = cartActiveElement.textContent;
  }

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        if (cartCountElement && cartActiveElement) {
          cartCountElement.textContent = cartActiveElement.textContent;
        }

        updateValues();
      }
    });
  });

  const config = { childList: true, subtree: true };
  observer.observe(cartActiveElement, config);

  const cartSubtotalElement = document.getElementById('CartSubtotal');
  const taxesElement = document.getElementById('taxes');
  const totalValueElement = document.getElementById('total-value');
  function updateValues() {
    let subtotalText;
    let subtotalValue;
    if (cartSubtotalElement) {
      subtotalText = cartSubtotalElement.textContent.trim();
      subtotalValue = parseFloat(subtotalText.replace(/[$,]/g, ''));
    }
    const itemCount = parseInt(cartActiveElement.textContent.trim(), 10);
    if (cartSubtotalElement) {
      if (!isNaN(subtotalValue) && !isNaN(itemCount)) {
        const percentage = 0.20;
        const taxesValue = (subtotalValue * percentage).toFixed(2);

        let totalValue = subtotalValue;

        if (itemCount === 1) {
          totalValue *= 1;
        }

        totalValueElement.textContent = `$${totalValue.toFixed(2)}`;
      }
    }
  }

  updateValues();

  const observerSubtotal = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        updateValues();
      }
    });
  });

  const configSubtotal = { childList: true, subtree: true, characterData: true };
  if (cartSubtotalElement) {
    observerSubtotal.observe(cartSubtotalElement, configSubtotal);
  }
});
document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.id === "iagree") {
          node.remove();
        }
      });
    });
  });


  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  function showAgreement() {
    $("#overlay").show();
    const modal = new tingle.modal({
      footer: true,
      stickyFooter: false,
      closeMethods: ["overlay", "button", "escape"],
      closeLabel: "Close",
      cssClass: ["iagree-class-1", "iagree-class-2"],
    });
    modal.setContent(
      '<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif;"><strong><span style="color: #ba372a; font-size: 18pt;">1. General</span></strong></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">1. This is the most recent Terms of Service (the &ldquo;terms&rdquo;) agreement as of September 5th, 2019.</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">2. These terms apply to your use of our website at artistpush.me (the &ldquo;website&rdquo;). Please read these terms carefully and ensure that you understand them before you start to use the website.</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">UNLESS YOU AGREE WITH ALL TERMS OF SERVICE FOR THE WEBSITE THEN PLEASE DO NOT ACCEPT THIS AGREEMENT AND THUS DO NOT BUY ANY SERVICES FROM OUR WEBSITE.</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">3. By accessing and using the website, you confirm that you accept these terms and that you agree to remain by them and any changes made to them from time to time.&nbsp;</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">4. We are the owner or the licensee of all intellectual property rights in the website, and in the material published on it. Typing errors on this website reserved.</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">5. If there are any contradictions with anything that has something to do with our website, and/or our Terms Of Service, the Terms Of Service rules are always right and applicable.&nbsp;</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif;"><strong><span style="color: #ba372a; font-size: 18pt;">2. Service</span></strong></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">1. This service will only be used for promotional purposes.</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">2.The materials we collect about you shall be used only for commercial propositions from our website. We do not sell or distribute personal information for any third party.&nbsp;&nbsp;</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">3. You will not upload anything into this service that includes nudity or any material that is not allowed or suitable.&nbsp;</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">4. You shall not intentionally use the system for your purpose.</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">5. The service seldom might deliver later than the planned date stated on the order page. Please contact our support team if your order didn\'t provide in time, they most likely will find a proper solution. Late delivery does not mean you will get a refund.</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">6. The quantity you purchase is not guaranteed. It can be a little more. If it&rsquo;s less, contact our support team.</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">7. The service we provide you use on your own (the buyer/customer) risk. We are not responsible for any of the consequences that may occur because of using our service.</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">8. However, in some cases, people might unfollow. In such a case, feel free to contact our support. They will possibly find a proper solution. You don\'t have the right to claim a refund in this case.</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">9. Users might be inactive or no real humans.</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif;"><strong><span style="color: #ba372a; font-size: 18pt;">3. Refund, Cancellation and Return Policy</span></strong></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">Considering digital marketing platform is offering non-tangible goods we do not issue refunds once the order is delivered and the service performed. As a customer, you are responsible for understanding this upon obtaining any item at our website.</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">Meanwhile, we understand that extraordinary situation can take place concerning the character of the service we supply.</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">Hence, we do the refund on the following reasons:&nbsp;</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">Service is not delivered: it also happens sometimes that we can\'t implement the service at all. Because of technical issues, broken links given by customers and other matter. In such a case we grant a full refund of your purchase.&nbsp;</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">Service not fully implemented: when the product not been full in mentioned time frames, we fitted to provide a partial refund or to offer our clients other suitable option.&nbsp;</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">The service was lost: we don\'t provide any refund when provided services dropped after two months after you purchased a service. You have to understand that promotional services are temporary, and for the best results, promotion should to be long term.</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">Artist Push desires our customers to be pleased with the services they purchase every time buying with us. The point regulates the issue of cancelation. A cancellation request can be made via e-mail artistpushnet@gmail.com.</span><br /><span style="color: #ba372a;">Cancellations will be admitted only if the request is made before 24 hours after your purchase.&nbsp;</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">Each order starting to proceed in 2 hours after purchase. We cancel the order and provide a 100% refund when the e-mail request for cancellation sent in 2 hours after purchase. When the request sent in 2 -12 hours - we provide a 25% refund, after 12 hours - 0%. ]</span><br /><br /><span style="color: #ba372a;">Please contact us if you have any issues regarding the service. Our support team is always anxious to serve you and perform highly professional support promptly. Thank you for purchasing from us.&nbsp;&nbsp;</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif;"><strong><span style="color: #ba372a; font-size: 18pt;">4. Privacy Policy</span></strong></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;"><a style="color: #ba372a;" href="https://artistpush.me/pages/privacy-policy">Privacy policy</a>&nbsp;covers how we use your personal information. We take your privacy seriously and will take all measures to protect your personal information.</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">Any personal information collected will only be handled to fulfill your order. We will not sell or distribute your information to any third party.</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">\u2757\uFE0FLiabilities:</span><br /><span style="color: #ba372a;">Artist Push&nbsp;is in no way liable for any account suspension or picture deletion done by Spotify, YouTube or Soundcloud or other social media or streaming services.</span></p>\n<p style="margin: 0px 0px 1em; line-height: 1.4; font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif; font-size: 15px;"><span style="color: #ba372a;">NOTE:&nbsp;ArtistPush isn\'t affiliated with Spotify, Apple Music/iTunes, Deezer, Tidal, Amazon Prime Music, Audiomack, Pandora &amp; any other streaming services. <a style="color: #ba372a;" title="Click" href="https://artistpush.me/pages/terms-and-conditions" target="_blank" rel="noopener">https://artistpush.me/pages/terms-and-conditions</a></span></p>'
    );
    modal.addFooterBtn("Close", "tingle-btn tingle-btn--primary", function () {
      modal.close();
      $("#overlay").hide();
    });
    modal.open();
  }

  function hideAgreement() {
    $("#overlay").hide();
  }
  function handleReturnClick(event) {
    event.preventDefault();
    window.history.back();
  }
});
document.addEventListener('DOMContentLoaded', () => {
  const searchContainers = [
    {
      button: document.querySelector('.search-icon'),
      input: document.querySelector('.search-menu')
    },
    {
      button: document.querySelector('.search-icon-mob'),
      input: document.querySelector('.search-mob')
    }
  ];

  searchContainers.forEach(({ button, input }) => {
    if (button && input) {
      button.addEventListener('click', (e) => {
        e.preventDefault();

        const searchValue = input.value.trim();
        if (!searchValue) {
          return;
        }

        // Save recent search when click icon search
        setOnClickRecentSearches(stripHtml(searchValue));

        // Check redirect when click icon search
        const redirects = getLocalStorage(ALL_REDIRECTS_KEY);

        if (redirects && redirects[searchValue.toLowerCase()]) {
          preventAllEvents(e);
          setWindowLocation(redirects[searchValue.toLowerCase()]);
          return;
        }

        setWindowLocation(generateSearchPageHref(searchValue));
      });
    }
  });
  document.querySelector('.search-scroll').addEventListener('click', function () {
    const searchMobContainer = document.querySelector('.header__search-mob');
    const searchIcon = document.querySelector('.search-scroll');
    searchMobContainer.classList.remove('hidden');
    searchMobContainer.classList.add('search-only-open');
    searchIcon.style.display = 'none';
    var menuIconMob = document.getElementById("menu-icon-mob");
    var menuIconMobClose = document.getElementById("menu-icon-mob-close");
    menuIconMob.classList.add("menu-hidden");
    menuIconMob.style.display = "none";
    menuIconMobClose.style.display = "block";
    const searchInput = searchMobContainer.querySelector('input[type="search"]');
    if (searchInput) {
      searchInput.focus();
    }
  });
  document.querySelectorAll('.menu-main-title').forEach(item => {
    item.addEventListener('mouseover', () => {
      const submenu = item.querySelector('.drop-submenu');
      if (submenu) {
        submenu.classList.add('show');
      }
    });

    item.addEventListener('mouseout', () => {
      const submenu = item.querySelector('.drop-submenu');
      if (submenu) {
        submenu.classList.remove('show');
      }
    });
  });
});


function stripHtml(html) {
  let doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || "";
}

function setOnClickRecentSearches(searchValue) {
  const recentSearchesKey = 'recentSearches';
  let recentSearches = getLocalStorage(recentSearchesKey) || [];

  if (!recentSearches.includes(searchValue)) {
    recentSearches.push(searchValue);
    if (recentSearches.length > 5) {
      recentSearches.shift();
    }
    setLocalStorage(recentSearchesKey, recentSearches);
  }
}

function getLocalStorage(key) {
  const value = localStorage.getItem(key);
  return value ? JSON.parse(value) : null;
}

function setLocalStorage(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

function preventAllEvents(event) {
  event.stopPropagation();
  event.preventDefault();
}

function setWindowLocation(url) {
  window.location.href = url;
}

function generateSearchPageHref(searchValue) {
  const baseSearchUrl = '/search';
  const params = new URLSearchParams();
  params.set('q', searchValue);
  return `${baseSearchUrl}?${params.toString()}`;
}

// Example redirects key
const ALL_REDIRECTS_KEY = 'allRedirects';
document.addEventListener("DOMContentLoaded", applyStyles);

window.addEventListener("resize", applyStyles);
